import { BalanceRoles } from '@Balance/index'
import { Button, ButtonVariant, Container, ContainerHeader } from '@Core/Components'
import { Input } from '@Core/Components/Input/Input'
import { Loader } from '@Core/Components/Loader/Loader'
import { RightContent } from '@Entry/Common/Header/Header.styles'
import { Divider } from '@material-ui/core'
import { PermissionsCard } from '@User/Common/PermissionsCard/PermissionsCard'

import { CommercialRoles } from '@Commercial/index'
import { Grid } from '@Core/Components/Grid/Grid'
import { EntryRoles } from '@Entry/index'
import { PurchasingRoles } from '@Purchasing/index'
import { InventoryRoles } from '@InventoryControl/index'
import { useUserManager } from '@User/Hooks/useUserManager/useUserManager'
import { UserRoles } from '..'
import { MicrosoftAccountSection } from './MicrosoftAccountSection'
import { PasswordExceptionSection } from './PasswordExceptionSection'
export const UserDetails = () => {
    const {
        user,
        loading,
        handleChangePermission,
        handleSave,
        handleChange,
        handleDisable,
        handleEnable,
        reloadUser,
    } = useUserManager()

    if (loading) return <Loader />

    return (
        <Container>
            <form onSubmit={(event) => event.preventDefault()}>
                <ContainerHeader className="m-2">
                    <h1 className="text-2xl font-bold">{user?.name}</h1>
                    <RightContent>
                        <Button type="button" onClick={handleSave}>
                            Salvar
                        </Button>
                        {user?.disabled && (
                            <Button
                                type="button"
                                onClick={handleEnable}
                                variant={ButtonVariant.secondary}
                            >
                                Ativar
                            </Button>
                        )}
                        {!user?.disabled && (
                            <Button
                                type="button"
                                onClick={handleDisable}
                                variant={ButtonVariant.secondary}
                            >
                                Desativar
                            </Button>
                        )}
                    </RightContent>
                </ContainerHeader>
                <Grid container lg={12} xs={12}>
                    <Grid item lg={6} xs={12}>
                        <Input
                            name="name"
                            label="Nome"
                            useUnform={false}
                            onChange={handleChange}
                            value={user?.name}
                            fullWidth
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <Input
                            name="mail"
                            label="E-mail"
                            type="email"
                            useUnform={false}
                            value={user?.mail}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>
                    <Grid item lg={12} xs={12}>
                        <Divider />
                    </Grid>
                    {user && (
                        <Grid item lg={12} xs={12}>
                            <MicrosoftAccountSection
                                user={user}
                                onChanged={reloadUser}
                            />
                        </Grid>
                    )}
                    {user && (
                        <Grid item lg={12} xs={12}>
                            <PasswordExceptionSection
                                user={user}
                                onChanged={reloadUser}
                            />
                        </Grid>
                    )}
                    <Grid item lg={12} xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item lg={12} xs={12}>
                        <h2>Permissões</h2>
                    </Grid>
                    <Grid container lg={12} xs={12}>
                        <Grid item lg={12} xs={12}>
                            <PermissionsCard
                                title="Controle de saldo"
                                roleItem={BalanceRoles}
                                userPermissions={user?.roles}
                                onChange={handleChangePermission}
                            />
                        </Grid>
                        <Grid item lg={12} xs={12}>
                            <PermissionsCard
                                title="Controle de Estoque"
                                roleItem={InventoryRoles}
                                userPermissions={user?.roles}
                                onChange={handleChangePermission}
                            />
                        </Grid>
                        <Grid item lg={12} xs={12}>
                            <PermissionsCard
                                title="Comercial"
                                roleItem={CommercialRoles}
                                userPermissions={user?.roles}
                                onChange={handleChangePermission}
                            />
                        </Grid>
                         <Grid item lg={12} xs={12}>
                            <PermissionsCard
                                title="Compras"
                                roleItem={PurchasingRoles}
                                userPermissions={user?.roles}
                                onChange={handleChangePermission}
                            />
                        </Grid>
                        <Grid item lg={12} xs={12}>
                            <PermissionsCard
                                title="Gestão de usuários"
                                roleItem={UserRoles}
                                userPermissions={user?.roles}
                                onChange={handleChangePermission}
                            />
                        </Grid>
                        <Grid item lg={12} xs={12}>
                            <PermissionsCard
                                title="Core"
                                roleItem={EntryRoles}
                                userPermissions={user?.roles}
                                onChange={handleChangePermission}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}
